import { MutationTree } from 'vuex';
import { CartState } from '../types';
import { ICart } from '@/models/CartModels';

const mutations: MutationTree<CartState> = {
  setCarts(state: CartState, carts: ICart[]) {
    state.carts = carts;
  },
  setViewedCartId(state: CartState, id: string) {
    state.viewedCartId = id;
  },
};

export default mutations;
